import { css } from 'styled-components';

export const withShadow = css`
  box-shadow: 0 0 4px 0 rgba(0,0,0,0.27);
  /* box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12); */
`;

export const withEllipsis = css`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
